module.exports = __webpack_public_path__ + "static/img/Utrecht Domplein.c88cfa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Utrecht Domplein.jpg
// module id = CXia
// module chunks = 1